// MUI
import Dialog from "@mui/material/Dialog";
import IconButon from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

// Components
import Button from "../../../../common/components/Button";
import Typography from "../../../../common/components/Typography";

// Utils
import { Colors } from "../../../../common/utils/constants";

// Icons
import Close from "@mui/icons-material/Close";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

// Images
import ShopBannerImage from "../../../../images/shop/shop_modal_banner.jpg";
import ShopMobileBannerImage from "../../../../images/shop/shop_modal_banner_mobile.jpg";

const ShopModal = ({ open, handleClose }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            sx={{
                "& .MuiPaper-root": {
                    height: { xs: "auto", lg: 486 },
                    backgroundSize: { xs: "contain", md: "cover" },
                    backgroundRepeat: "no-repeat",
                    position: "relative",
                    backgroundImage: {
                        xs: `url(${ShopMobileBannerImage})`,
                        md: `url(${ShopBannerImage})`,
                    },
                },
            }}
        >
            <Stack padding={3} height={"100%"} alignItems={"end"}>
                <Stack alignItems={"end"}>
                    <IconButon onClick={handleClose}>
                        <Close sx={{ color: Colors.white }} />
                    </IconButon>
                </Stack>
                <Stack
                    width={{ xs: "100%", md: "50%" }}
                    height={"100%"}
                    spacing={3}
                    justifyContent={"space-between"}
                    zIndex={1}
                    pt={{ xs: 10, md: 0 }}
                >
                    <Stack spacing={3}>
                        <Typography
                            variant="h1"
                            sx={{ color: { md: Colors.white } }}
                        >
                            Visit our new Resolute shop
                        </Typography>
                        <Typography
                            variant="paragraph"
                            sx={{ color: { md: Colors.white } }}
                        >
                            Welcome to your hub for coding and robotics
                            exploration! Discover innovative learning
                            experiences designed for individuals of all ages and
                            skill levels. Ignite your creativity, embrace
                            technology, and embark on a journey to master coding
                            and robotics. Join us to unlock your potential and
                            shape the future of innovation!
                        </Typography>
                    </Stack>

                    <Stack alignItems={"end"}>
                        <Button
                            variant={"outlined"}
                            sx={{
                                color: Colors.white,
                                borderColor: Colors.white,
                                width: "fit-content",
                                alignSlef: "flex-end",
                                display: { xs: "none", md: "flex" },
                            }}
                            endIcon={<OpenInNewRoundedIcon />}
                            onClick={() =>
                                window.open(
                                    "https://shop.resolute.education/",
                                    "_blank"
                                )
                            }
                        >
                            Shop Now
                        </Button>
                        <Button
                            variant={"contained"}
                            sx={{
                                width: "fit-content",
                                alignSlef: "flex-end",
                                display: { xs: "flex", md: "none" },
                            }}
                            endIcon={<OpenInNewRoundedIcon />}
                            onClick={() =>
                                window.open(
                                    "https://shop.resolute.education/",
                                    "_blank"
                                )
                            }
                        >
                            Shop Now
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
        </Dialog>
    );
};

export default ShopModal;
